import SpNavi from './SpNavi';

/* ===============================================
SP Navi
=============================================== */
const spNaviSpeed = 200;
const adjustPX = 20;
const $spNaviScroller = $('#scroller');

const param = {
    target: '#spnavi',
    trigger: '.btn_sp_navi',
    filter: '.spnavi-bg',
    speed: spNaviSpeed
};
const spnavi = new SpNavi(param);

const refreshScroller = (s) => {
    const r = s.refresh();
}
const adjustmentNavPosition = (navHeight, s) => {
    const adjust = navHeight - $(window).height();

    if (adjust > adjustPX) {
        $spNaviScroller.animate({
            'bottom': (-1 * adjust) + adjustPX
        }, spNaviSpeed, 'swing', function () {
            refreshScroller(s);
        })
    } else {
        $spNaviScroller.animate({
            'bottom': 0
        }, 1, 'swing', function () {
            refreshScroller(s);
        })
    }
}
const resetNavPosition = (s) => {
    $spNaviScroller.animate({
        'bottom': 0
    }, 1, 'swing', function () {
        refreshScroller(s);
    })
}
/**
 *
 * @param {Object} scroller iscrollのスクロールエリアオブジェクト
 *
 * SPナビの展開時にフックしてアコーディオン処理
 * 子ナビの内蔵メニューが増えた際にも対応
 */
const spnav_accordion_1 = (scroller) => {
    const _$trigger = $('#scroller .global_nav-item a');
    const _$nav_holder = $('.spnavi-child-holder');
    let _id_holder = '';

    _$trigger.off();
    _$trigger.on('click', function () {
        const id = $(this).attr('href');
        if ($(id).length == 0) return;

        if (!_$nav_holder.hasClass('_is-open')) {
            _$nav_holder.addClass('_is-open').removeClass('_is-close');
        } else if (_id_holder == id) {
            _$nav_holder.addClass('_is-close').removeClass('_is-open');
            $(id).fadeOut(100, function () {
                resetNavPosition(scroller);
            });

            return false;
        }

        _id_holder = id;

        if ($(id).length > 0) {
            $('.spnavi-child').hide();

            if ($(id).css('display') == 'block') {
                $(id).fadeOut(spNaviSpeed, () => {
                    resetNavPosition(scroller);
                });
            } else {
                $(id).fadeIn(spNaviSpeed, () => {
                    adjustmentNavPosition($('.spnavi-inner').outerHeight(), scroller);
                });
            }
            return false;
        }

        return false;
    });
}
spnavi.exec(spnav_accordion_1);